import { render, staticRenderFns } from "./CampaignHeader.vue?vue&type=template&id=6a2d7688&scoped=true"
import script from "./CampaignHeader.vue?vue&type=script&lang=js"
export * from "./CampaignHeader.vue?vue&type=script&lang=js"
import style0 from "./CampaignHeader.vue?vue&type=style&index=0&id=6a2d7688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d7688",
  null
  
)

export default component.exports